import { render, staticRenderFns } from "./ModalAddDates.vue?vue&type=template&id=2600a85e&scoped=true&"
import script from "./ModalAddDates.vue?vue&type=script&lang=js&"
export * from "./ModalAddDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600a85e",
  null
  
)

export default component.exports